/**
 * @generated SignedSource<<3541e5b941a8dcd533ce3fbdd8578d9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ContactInfoState = "DRAFT" | "VERIFIED";
export type ContactInfoType = "EMAIL" | "PHONE";
export type ContactInfoPageQuery$variables = Record<PropertyKey, never>;
export type ContactInfoPageQuery$data = {
  readonly contactInfo: {
    readonly id: string;
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly state: ContactInfoState;
      readonly type: ContactInfoType;
      readonly value: string;
    }>;
  };
  readonly me: {
    readonly email: string;
    readonly id: string;
    readonly phone: string;
  };
};
export type ContactInfoPageQuery = {
  response: ContactInfoPageQuery$data;
  variables: ContactInfoPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Me",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phone",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ContactInfoList",
    "kind": "LinkedField",
    "name": "contactInfo",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ContactInfo",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactInfoPageQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ContactInfoPageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9e3da35eceb5c24135d0fbb6cb5ffdeb",
    "id": null,
    "metadata": {},
    "name": "ContactInfoPageQuery",
    "operationKind": "query",
    "text": "query ContactInfoPageQuery {\n  me {\n    id\n    email\n    phone\n  }\n  contactInfo {\n    id\n    nodes {\n      id\n      type\n      value\n      state\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "72ad9661c1f1ef7bae17834b526a188b";

export default node;
